import React, { useContext } from "react";
import { ConfirmDialog, useNotifications } from "sprint-common-web";

import { useOrdersModuleApi } from "../../../common/useOrdersModuleApi";
import { OrderListingContext } from "../context/OrderListingContext";
import { OrderListingItem } from "../OrderListingItem";

type RemoveOrderWatermarkDialogProps = {
    isOpen: boolean;
    item: OrderListingItem;
    onCancel(): void;
    onSubmit(): void;
};

export const RemoveOrderWatermarkDialog: React.VFC<RemoveOrderWatermarkDialogProps> = ({
    item,
    isOpen,
    onCancel,
    onSubmit
}: RemoveOrderWatermarkDialogProps) => {
    const { updateOrder } = useContext(OrderListingContext);
    const { removeOrderWatermark } = useOrdersModuleApi();
    const { success, error } = useNotifications();

    const handleSubmit = () => {
        removeOrderWatermark({ orderId: item.id })
            .then(() => {
                updateOrder({ id: item.id, isWatermark: false });

                onSubmit();

                success("Watermark removed");
            })
            .catch(() => {
                error("Cannot remove watermark");
            });
    };

    return (
        <ConfirmDialog
            title="Request order watermark"
            text="Are you sure you want to re watermark rule?"
            hidden={!isOpen}
            confirm={{ onClick: handleSubmit }}
            cancel={{ onClick: onCancel }}
            width={500}
        />
    );
};
